import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./components/notifyToast";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import { useProtect } from "./hooks/useProtect";
import Login from "./pages/Login";
import AdminLogin from "./pages/AdminLogin";
import AdminUsers from "./pages/AdminUsers";
import AdminAppUpdate from "./pages/AdminAppUpdate";
import AdminBrands from "./pages/AdminBrands";
import LoginHistory from "./pages/LoginHistory";
import AdminLoginHistory from "./pages/AdminLoginHistory";
import AuthCallback from "./components/AuthCallback";
import Layout from "./components/Layout";
import AccessGate from "./components/AccessGate";
import Home from "./pages/Home";
import Workspace from "./pages/Workspace";
import DesktopSettings from "./pages/DesktopSettings";
import Database from "./pages/Database";
import Pinout from "./pages/Pinout";
import FileService from "./pages/FileService";
import HexTool from "./pages/HexTool";
import HondaTitanChecksum from "./pages/HondaTitanChecksum";
import XdfAdxToolkit from "./pages/XdfAdxToolkit";
import ImmoCalculator from "./pages/ImmoCalculator";
import RecoveryGenerator from "./pages/RecoveryGenerator";
import ShindengenSeedKey from "./pages/ShindengenSeedKey";
import MapEditor from "./pages/MapEditor";
import DesktopDownload from "./pages/DesktopDownload";
import EcuDatabase from "./pages/EcuDatabase";
import EcuLibrary from "./pages/EcuLibrary";
import HondaFlashtools from "./pages/HondaFlashtools";
import McuReadWrite from "./pages/McuReadWrite";
import YamahaFlashtools from "./pages/YamahaFlashtools";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/" element={typeof window !== "undefined" && window.tiroDesktopApp ? <Navigate to="/workspace" replace /> : typeof window !== "undefined" && window.tiroDesktop ? <Navigate to="/map-editor" replace /> : <Home />} />
      <Route element={<Layout />}>
        <Route path="/workspace" element={<Workspace />} />
        <Route path="/settings" element={<DesktopSettings />} />
        <Route path="/database" element={<Database />} />
        <Route path="/pinout" element={<AccessGate featureId="pinout" pageTitle="ECU Pinout"><Pinout /></AccessGate>} />
        <Route path="/honda-flashtools" element={<AccessGate featureId="map-editor" pageTitle="Honda Flash Tools"><HondaFlashtools /></AccessGate>} />
        <Route path="/mcu-read-write" element={<AccessGate featureId="mcu-read-write" pageTitle="MCU Read/Write"><McuReadWrite /></AccessGate>} />
        <Route path="/mpc5602d-flash" element={<Navigate to="/mcu-read-write" replace />} />
        <Route path="/yamaha-flashtools" element={<AccessGate featureId="map-editor" pageTitle="Yamaha Flash Tools"><YamahaFlashtools /></AccessGate>} />
        <Route path="/file-service" element={<FileService />} />
        <Route path="/bin-converter" element={<HexTool />} />
        <Route path="/honda-titan-checksum" element={<HondaTitanChecksum />} />
        <Route path="/xdf-adx-toolkit" element={<AccessGate featureId="xdf-adx" pageTitle="XDF / ADX Unlock"><XdfAdxToolkit /></AccessGate>} />
        <Route path="/immo-calculator" element={<AccessGate featureId="immo" pageTitle="IMMO Service"><ImmoCalculator /></AccessGate>} />
        <Route path="/recovery-generator" element={<AccessGate featureId="recovery" pageTitle="Recovery Generator"><RecoveryGenerator /></AccessGate>} />
        <Route path="/shindengen-seedkey" element={<AccessGate featureId="seed-key" pageTitle="Seed Key View" adminOnly><ShindengenSeedKey /></AccessGate>} />
        <Route path="/map-editor" element={<AccessGate featureId="map-editor" pageTitle="Map Editor"><MapEditor /></AccessGate>} />
        <Route path="/admin/desktop" element={<DesktopDownload />} />
        <Route path="/admin/ecu-database" element={<EcuDatabase />} />
        <Route path="/admin/ecu-library" element={<EcuLibrary />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/app-update" element={<AdminAppUpdate />} />
        <Route path="/admin/brands" element={<AdminBrands />} />
        <Route path="/riwayat-login" element={<AccessGate featureId="login-history" pageTitle="Riwayat Login" adminOnly><LoginHistory /></AccessGate>} />
        <Route path="/admin/login-history" element={<AdminLoginHistory />} />
      </Route>
    </Routes>
  );
}

function AppToaster() {
  return <Toaster position="top-center" offset="42vh" theme="dark" duration={2500} style={{ "--width": "min(92vw, 480px)", fontFamily: "inherit" }} />;
}

function App() {
  useProtect();
  return (
    <div className="App">
      <AuthProvider>
        <I18nProvider>
          <BrowserRouter>
            <AppToaster />
            <AppRouter />
          </BrowserRouter>
        </I18nProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
